import polpoApi from './polpoApi';

export default {
  login: async (credentials) => polpoApi.post('users/login', credentials),
  logout: async () => polpoApi.get('users/logout'),
  register: async (userData) => polpoApi.post('users/register', userData),
};
